import React, { useEffect } from "react";
import { useAppContext } from "../../classes/contexts/AppContext";
import useTranslation from "../../hooks/i18n/useTranslation";

import { Units } from "./widgets/units/Units";
import { Region } from "./widgets/region/Region";
import { Visual } from "./widgets/visual/Visual";
import { SpinoPelvic } from "./widgets/spino-pelvic/SpinoPelvic";

import "./styles/Settings.css";

export const Settings = () => {
  const { t } = useTranslation();
  const { hideSidebars } = useAppContext();

  useEffect(() => {
    hideSidebars();
  }, [hideSidebars]);

  return (
    <div className="settings-container">
      {/* Header */}
      <div className="settings-container-header">
      <h1>{t("25")}</h1>
      </div>

      {/* Main Content Block */}
      <div className="settings-container-content">
        <section className="settings-container-main">
          <Units />
          <Region />
          <Visual />
        </section>

        {/* Spino-pelvic Parameters */}
        <SpinoPelvic />
      </div>
    </div>
  );
};
